import { Either, Right } from "purify-ts/Either";
import { formatDate } from "../utils/dateValidationMsg";
import { Nothing, Maybe } from "purify-ts";
import { Bruksklasse } from "./arbeid";
import {
  Field,
  initialField,
} from "@nvdb-rapport/shared/src/components/formTypes";
import * as R from "remeda";

export interface PubliseringModel {
  selectedBruksklasse: Field<Bruksklasse | undefined>;
  vegsystem: string;
  date: Field<Either<string, string>>;
  selectedFylke: Field<Maybe<number>>;
  selectedReadversion: Field<boolean | undefined>;
}

export const initialPubliseringModel: PubliseringModel = {
  selectedBruksklasse: initialField(undefined),
  vegsystem: "EV,RV",
  date: initialField(Right(formatDate(new Date()))),
  selectedFylke: initialField(Nothing),
  selectedReadversion: initialField(true),
};

type UpdateVegsystem = { type: "UpdateVegsystem"; payload: string };
type SelectDate = { type: "SelectDate"; payload: Either<string, string> };
type SelectFylke = { type: "SelectFylke"; payload: Field<Maybe<number>> };
type Touch = { type: "Touch"; payload: keyof PubliseringModel };
type SelectBruksklasse = {
  type: "SelectBruksklasse";
  payload: Field<Bruksklasse | undefined>;
};
type SelectReadversion = {
  type: "SelectReadversion";
  payload: Field<boolean | undefined>;
};

export type PubliseringAction =
  | UpdateVegsystem
  | SelectDate
  | SelectFylke
  | Touch
  | SelectBruksklasse
  | SelectReadversion;

export function publiseringReducer(
  model: PubliseringModel,
  action: PubliseringAction
): PubliseringModel {
  switch (action.type) {
    case "UpdateVegsystem":
      return R.pipe(model, R.set("vegsystem", action.payload));
    case "SelectDate":
      return {
        ...model,
        date: { ...model.date, value: action.payload, dirty: true },
      };
    case "SelectFylke":
      return R.pipe(model, R.set("selectedFylke", action.payload));

    case "SelectBruksklasse": {
      return R.pipe(model, R.set("selectedBruksklasse", action.payload));
    }
    case "SelectReadversion": {
      return R.pipe(model, R.set("selectedReadversion", action.payload));
    }
    case "Touch":
      if (action.payload === "selectedBruksklasse") {
        return {
          ...model,
          [action.payload]: { ...model[action.payload], touched: true },
        };
      } else {
        return { ...model };
      }
  }
}
